import React from 'react';
import {useSelector} from 'react-redux';

function Window({title, children}) {
  const notificationCount = useSelector(state => state.notificationCount);

  React.useEffect(() => {
    let formatted = 'Agyle Intelligence';

    if (title) {
      formatted = `${title} - ${formatted}`;
    }
    
    if (notificationCount > 0) {
      formatted = `(${notificationCount}) ${formatted}`;
    }

    document.title = formatted;
  }, [title, notificationCount]);

  return children;
}

export default Window;
